import models from './models'
import menu from './menu'
import routes from './routes'

export default {

  name: 'Customers',

  setup () {
    return {
      menu,
      routes
    }
  },

  models () {
    return {
      'customer': models.Customer,
      'customer:address': models.Address,
      'address': models.Address,
      'customer:subscription': models.Subscription,
      'customer:group': models.CustomerGroup
    }
  }

}
